import { render, staticRenderFns } from "./SelectStatut.vue?vue&type=template&id=2f99e3e0"
import script from "./SelectStatut.vue?vue&type=script&lang=js"
export * from "./SelectStatut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports